import {
  WINDOW_EVT_RESIZE,
  windowEventHelperModule,
} from '../../../../shared/app/helpers/window-event-helper/window-event-helper';

function determineWhereElementIsInViewport($el, viewportHeight, delayPercent) {
  const elementBounds = $el[0].getBoundingClientRect();

  const panelTop = elementBounds.top;
  const panelBottom = elementBounds.bottom;

  // pixel buffer until deciding to show the element
  const delayPx = delayPercent * elementBounds.height;

  const topAboveHalf = panelTop < viewportHeight / 2;
  const bottomVisible =
    topAboveHalf && panelBottom - delayPx > 0 && panelBottom < viewportHeight;
  const topVisible =
    topAboveHalf && panelTop + delayPx <= viewportHeight && panelTop > 0;

  if ($el.data('hidden') && (bottomVisible || topVisible)) {
    // scrolled into view
    return true;
  } else if (
    !$el.data('hidden') &&
    (panelBottom < 0 || panelTop > viewportHeight)
  ) {
    // scrolled out of view
    return false;
  }

  // no change
  return null;
}

export const onScrollAddClassComponentModule = angular
  .module('Q.components.on-scroll-add-class', [windowEventHelperModule])
  .directive('onScrollAddClass', function ($document, $window, $timeout) {
    const delayPercent = 0.5; // lower = more eager to hide / show, higher = less eager
    const document = $document[0].documentElement;

    return {
      restrict: 'A',
      require: ['onScrollAddClass', '^?hasSteps'],
      controller: function () {},

      link(scope, el, attr, [onScrollAddClassCtrl, hasStepsCtrl]) {
        let checkPending = false;
        let lastStarted = -Infinity;

        function onScroll() {
          if (!checkPending) {
            checkPending = true;
            $window.requestAnimationFrame(() => {
              let setVisibility = determineWhereElementIsInViewport(
                el,
                document.clientHeight,
                delayPercent,
              );
              if (setVisibility !== null) {
                toggleVisible(setVisibility);
              }
              checkPending = false;
            });
          }
        }

        let isFinishedTimeout = null;

        function toggleVisible(visible, force = false) {
          // don't re-run within 10s
          if (!force && Date.now() - lastStarted < 10000) return;

          let wasVisible = !el.data('hidden');
          el.toggleClass(attr.onScrollAddClass || 'is-visible', visible);
          el.data('hidden', !visible);

          // animation finished styling
          if (!visible || !wasVisible) {
            el.removeClass('is-finished');
            if (isFinishedTimeout) {
              $timeout.cancel(isFinishedTimeout);
              isFinishedTimeout = null;
            }
            let runtime = 1000 * attr.onScrollRuntime;
            if (visible) {
              lastStarted = Date.now();
            }
            if (visible && runtime) {
              isFinishedTimeout = $timeout(
                () => {
                  el.addClass('is-finished');
                },
                runtime,
                false,
              );
            }
          }
        }

        const documentListenerEvents = 'scroll';
        $document.on(documentListenerEvents, onScroll);
        scope.$on(WINDOW_EVT_RESIZE, onScroll);
        scope.$on('$destroy', function () {
          $document.off(documentListenerEvents, onScroll);
        });

        // initialise
        scope.$evalAsync(onScroll);
        onScrollAddClassCtrl.runAnimation = () => {
          if (!el.data('hidden')) {
            $window.requestAnimationFrame(() => {
              toggleVisible(false, true);
              $window.requestAnimationFrame(() => toggleVisible(true, true));
            });
          }
        };

        if (hasStepsCtrl) {
          hasStepsCtrl.add(onScrollAddClassCtrl.runAnimation);
        }
      },
    };
  })

  .directive('hasSteps', function ($timeout, $interval) {
    return {
      restrict: 'A',
      controller: function () {
        const anims = [];
        this.add = (animFn) => anims.push(animFn);
        this.runAnim = () => {
          anims.forEach((animFn) => animFn());
        };
      },
      link(scope, el, attr, hasStepsCtrl) {
        const $inputs = el.querySelectorAll('input');
        const $labels = el.querySelectorAll('labels');

        let timerRunning = false;
        let active = 0;

        const startTimer = (setActive = active) => {
          if (timerRunning) return;
          active = setActive;
          timerRunning = true;
          const timer = $interval(
            () => {
              if (timerRunning) {
                active = (active + 1) % $inputs.length;
                $inputs.prop('checked', false);
                $inputs.eq(active).prop('checked', true);
                hasStepsCtrl.runAnim();
              } else {
                $interval.cancel(timer);
              }
            },
            10 * 1000,
            false,
          ); // auto-switch active step every 10 seconds
        };
        startTimer();
        $inputs.on('change', () => {
          hasStepsCtrl.runAnim();
        });

        let restartTimer;
        const clickOnOption = (event, $elements) => {
          timerRunning = false;
          hasStepsCtrl.runAnim();
          if (restartTimer) {
            $timeout.cancel(restartTimer);
          }
          // restart switching timer after 3 minutes
          restartTimer = $timeout(
            () => {
              const target = event.target;
              const idx = Array.from($elements).indexOf(target);
              startTimer(idx > -1 ? idx : active);
            },
            3 * 60 * 1000,
            false,
          );
        };

        $inputs.on('click', (event) => {
          clickOnOption(event, $inputs);
        });
        $labels.on('click', (event) => {
          clickOnOption(event, $labels);
        });
      },
    };
  })

  .directive('onScrollAddClassClickable', function () {
    return {
      restrict: 'A',
      require: '^onScrollAddClass',
      link(scope, el, attr, onScrollAddClassCtrl) {
        el.on('click', () => onScrollAddClassCtrl.runAnimation());
      },
    };
  });
